import { all, takeEvery } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';
import { fetchWrapperFuncNoLoading } from '../../../utils';
import { getWebUsageApi, ServerType } from '../../System/systemConfig';
import { sysadminSetWebUsage, SYSADMIN_LOAD_WEB_USAGE, SYSADMIN_LOAD_WEB_USAGE_DETAILS, sysadminSetWebUsageDetails } from './actions';

function* webUsageLoadGenerator(action: Action<ServerType>) {
    const server = action.payload;
    const api = getWebUsageApi(server);

    yield* fetchWrapperFuncNoLoading(() => api.getWebUsageSummary(), [r => sysadminSetWebUsage({ server, usage: r })]);
}

function* webUsageLoadDetailsGenerator(action: Action<ServerType>) {
    const server = action.payload;
    const api = getWebUsageApi(server);

    yield* fetchWrapperFuncNoLoading(() => api.getWebUsageList(), [r => sysadminSetWebUsageDetails({ server, usage: r })]);
}
function* watchForWebUsageActions() {
    yield takeEvery(SYSADMIN_LOAD_WEB_USAGE, webUsageLoadGenerator);
    yield takeEvery(SYSADMIN_LOAD_WEB_USAGE_DETAILS, webUsageLoadDetailsGenerator);
}

export function* webUsageSagas() {
    yield all([watchForWebUsageActions()]);
}
